export function createClickId(_ref) {
  let {
    data,
    parent
  } = _ref;
  // clickID structure provided by Analytics request
  const clickIdString = `ip-_-${parent.name}-_-${parent.id}-_-${data.name}-_-${data.position}-_-${data.id}`;
  return clickIdString;
}
//# sourceMappingURL=createClickId.js.map